import React from 'react'
import PropTypes from 'prop-types'

import { Modal, Button, BUTTON_THEME, BUTTON_COLOR } from '@st-operations/uikit/src/v2/index.js'
import ProgressChart from '../../../components/progress-chart/index.jsx'

import './styles.scss'

const MODAL_CLASSES = {
  content: 'batch-process-modal__container',
  childWrapper: 'batch-process-modal__wrapper',
  innerWrapper: 'batch-process-modal__inner-wrapper',
  headerClose: 'batch-process-modal__close-button',
}

const ImportAudiencesProcessModal = ({
  className,
  title,
  subtitle,
  isOpen,
  onCancel,
  percentage,
}) => (
  <Modal className={className} classes={MODAL_CLASSES} isOpen={isOpen}>
    <section className="batch-process-modal__content">
      <h1 className="batch-process-modal__title">{title}</h1>
      <p className="batch-process-modal__description">{subtitle}</p>
      <div className="batch-process-modal__progress-chart-wrapper">
        <ProgressChart className="batch-process-modal__progress-chart" percentage={percentage} />
      </div>
      {percentage < 1 && (
        <Button theme={BUTTON_THEME.SECONDARY} color={BUTTON_COLOR.RED} onClick={onCancel}>
          Cancel Import
        </Button>
      )}
    </section>
  </Modal>
)

ImportAudiencesProcessModal.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  percentage: PropTypes.number,
}

ImportAudiencesProcessModal.defaultProps = {
  className: '',
  title: '',
  subtitle: '',
  isOpen: false,
  percentage: 0,
}

export default React.memo(ImportAudiencesProcessModal)
